import {
  AudienceQuestionTranslation,
  AudienceResponseOptionTranslation
} from '../../data/model/audience'

// Standard/targeting (and global custom) audience questions store the English
// master in `text`/`value` and the per-locale text in `translations`, keyed by
// a bare ISO-639-1 language code. For display we overlay the current market's
// translation over the master. Language codes are matched case-insensitively.

const matchesLanguage = (
  translationLanguage: string | undefined,
  marketLanguage: string
): boolean =>
  !!translationLanguage &&
  translationLanguage.toLowerCase() === marketLanguage.toLowerCase()

/**
 * The market-language question text, falling back to the English master when
 * there is no (non-empty) translation for the language. The fallback also
 * covers legacy surveys whose master `text` is already localised and whose
 * `translations` are empty.
 */
export const overlayQuestionText = (
  masterText: string,
  translations: AudienceQuestionTranslation[] | null | undefined,
  marketLanguage: string | undefined
): string => {
  if (!marketLanguage) return masterText
  const translation = translations?.find((t) =>
    matchesLanguage(t.language, marketLanguage)
  )
  return translation?.text.trim() ? translation.text : masterText
}

/**
 * The market-language response-option value, falling back to the English master
 * when there is no (non-empty) translation for the language.
 */
export const overlayOptionValue = (
  masterValue: string,
  translations: AudienceResponseOptionTranslation[] | null | undefined,
  marketLanguage: string | undefined
): string => {
  if (!marketLanguage) return masterValue
  const translation = translations?.find((t) =>
    matchesLanguage(t.language, marketLanguage)
  )
  return translation?.value.trim() ? translation.value : masterValue
}
